import Finance from '../../views/Finance/Finance.view';

export default Finance;
